import React from 'react';

export default class FooterPublic extends React.Component{
    render(){
        return (
            <div className="text-muted text-sm">
               Terms of Use. Privacy Policy.
            </div>
        );
    }
}
